export default __webpack_public_path__ + "static/media/hht1_ep12_book_wp_02.775b7ed5.jpg";